export const getNavigationQueryKey = (culture: string, market: string) => `/content/navigation/${culture}/${market}`;
